/**
 * @file: oem.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export { __oemConfig__ as oemConfig } from './oem-confs/com.zhichetech';
